import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const ChangePassword = Loadable({
  loader: () =>
    import(/* webpackChunkName: "ChangePassword" */ '../containers/ChangePassword'),
  loading: DefaultLoadingScreen,
});

const ChangePasswordScreen = props => <ChangePassword {...props} />;
ChangePasswordScreen.navigationOptions = {
  headerTitle: <HeaderOneLine title="Ganti Kata Sandi" />,
};
export default ChangePasswordScreen;
